import script from "./customFieldListViewColumn.vue?vue&type=script&setup=true&lang=js"
export * from "./customFieldListViewColumn.vue?vue&type=script&setup=true&lang=js"

import "./customFieldListViewColumn.vue?vue&type=style&index=0&id=a4345724&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4345724"]])

export default __exports__